export default "__VITE_ASSET__DW3RbO4S__"